import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetDepartments,
  CreateDepartment,
  UpdateDepartment,
  DeleteDepartment,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const departmentQueryKeys = {
  departments: () => ["departments"] as const,
};

export const invalidateDepartmentQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["departments"] });
};

export const useDepartmentsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: departmentQueryKeys.departments(),
    queryFn: async () => unwrapApiResponse(await GetDepartments()),
  });
};

export const useActiveDepartmentsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: departmentQueryKeys.departments(),
    queryFn: async () => unwrapApiResponse(await GetDepartments()),
  });
};

export const useDepartmentsRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery({
        staleTime: LOOKUP_STALE_TIME,
        queryKey: departmentQueryKeys.departments(),
        queryFn: async () => unwrapApiResponse(await GetDepartments()),
      }),
  });
};

export const useCreateDepartmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateDepartment>[0]) =>
      CreateDepartment(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDepartmentQueries(queryClient);
      }
    },
  });
};

export const useUpdateDepartmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateDepartment>[0]) =>
      UpdateDepartment(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDepartmentQueries(queryClient);
      }
    },
  });
};

export const useDeleteDepartmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteDepartment>[0]) =>
      DeleteDepartment(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDepartmentQueries(queryClient);
      }
    },
  });
};
